import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';
import { useTranslation } from 'react-i18next';
import { ReactNode } from 'react';
import { getLoginRoute } from '@/common/routes.common';

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { user, loading } = useAuth();
  const { t } = useTranslation();
  const location = useLocation();

  if (loading) {
    return <div>{t('common.loading')}</div>;
  }

  if (!user) {
    return <Navigate to={getLoginRoute(`${location.pathname}${location.search}`)} replace />;
  }

  return <>{children}</>;
}
